/* eslint-disable import/prefer-default-export */
export const styles = {
  timeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputsContainer: {
    width: '100%',
    margin: '5px',
    height: '100px',
    border: '1px solid #cfccce',
    padding: '10px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  inputDias: {
    width: '250px',
  },
  inputPercent: {
    width: '160px',
  },
  timeTitle: {
    fontFamily: 'Nunito, Helvetica, Arial, sans-serif',
    fontWeight: 'bold',
    marginBottom: '3px',
    textDecoration: 'none',
  },
  errorTitle: {
    fontFamily: 'Nunito, Helvetica, Arial, sans-serif',
    fontWeight: 'bold',
    marginBottom: '3px',
    textDecoration: 'none',
    textAlign: 'center',
    color: 'red',
  },

};
